// Export for use with NPM & Node.js.
export {ScratchStorage} from './ScratchStorage';
export {
    default as Asset,
    type AssetId,
    type AssetData
} from './Asset';
export {
    AssetType,
    type IAssetType
} from './AssetType';
export {DataFormat} from './DataFormat';
export {default as Helper} from './Helper';
